import { useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { AlertCircle, Check, Copy } from "lucide-react";
import { toast } from "sonner";

export function ApiKeyCreatedDialog({ open, onOpenChange, keyData }) {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    if (!keyData?.full_key) return;
    try {
      await navigator.clipboard.writeText(keyData.full_key);
      setCopied(true);
      toast.success("API key copied to clipboard");
      setTimeout(() => setCopied(false), 2000);
    } catch {
      toast.error("Failed to copy to clipboard");
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>API Key Created</DialogTitle>
          <DialogDescription>
            Your new API key has been created successfully.
          </DialogDescription>
        </DialogHeader>

        <div className="space-y-4 py-2">
          <div className="flex items-start gap-2 p-3 bg-amber-50 border border-amber-200 rounded-lg text-amber-800">
            <AlertCircle className="h-4 w-4 mt-0.5 shrink-0" />
            <p className="text-sm">
              Make sure to copy your API key now. You won't be able to see it again.
            </p>
          </div>

          <div className="flex items-center gap-2">
            <Input
              readOnly
              value={keyData?.full_key || ""}
              className="font-mono text-xs"
            />
            <Button variant="outline" size="icon" onClick={handleCopy} className="shrink-0">
              {copied ? (
                <Check className="h-4 w-4 text-green-600" />
              ) : (
                <Copy className="h-4 w-4" />
              )}
            </Button>
          </div>
        </div>

        <DialogFooter>
          <Button onClick={() => onOpenChange(false)} className="w-full">
            I've Copied My Key
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
